import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";

export default function TokenExpiredModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("portal-token-expired", handler);
    return () => window.removeEventListener("portal-token-expired", handler);
  }, []);

  const handleLogin = () => {
    sessionStorage.removeItem("portal_token");
    sessionStorage.removeItem("portal_user");
    window.location.href = "/login";
  };

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <LockOutlined color="warning" />
        Sessione scaduta
      </DialogTitle>
      <DialogContent>
        <Typography>
          La tua sessione è scaduta. Effettua nuovamente il login per continuare.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleLogin}>
          Vai al login
        </Button>
      </DialogActions>
    </Dialog>
  );
}
